import { render, staticRenderFns } from "./addFollowUp.vue?vue&type=template&id=0b52bdde&scoped=true&"
import script from "./addFollowUp.vue?vue&type=script&lang=js&"
export * from "./addFollowUp.vue?vue&type=script&lang=js&"
import style0 from "./addFollowUp.vue?vue&type=style&index=0&id=0b52bdde&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b52bdde",
  null
  
)

export default component.exports